import isEmpty from 'lodash/isEmpty';

// helpers
import { prepareFilterParam } from '/src/lib/queryParams';
import { amountFormatter } from '/src/lib/helpers';

export const prepNewFilters = (oldFilters, newFilters, filterOptions = {}) => {
    let arFilters = [];

    Object.keys(oldFilters).map(key => {
        if (key === 'keyword' && oldFilters[key].length > 0) {
            newFilters.keyword.value = oldFilters[key];

            arFilters.push(newFilters.keyword);

        } else if (key === 'startup' && !isEmpty(oldFilters[key])) {
            newFilters.startup_num.value = [oldFilters[key]['min'].toString(), oldFilters[key]['max'].toString()];

            arFilters.push(newFilters.startup_num);
        } else if (key === 'investment_date' && oldFilters[key]) {
            const tempFromValue = oldFilters[key].from ? oldFilters[key].from : new Date(0);
            const fromVal = `${tempFromValue.getFullYear()}-${tempFromValue.getMonth() + 1}-${tempFromValue.getDate()}`;

            const tempToValue = oldFilters[key].to ? oldFilters[key].to : new Date();
            const toVal = `${tempToValue.getFullYear()}-${tempToValue.getMonth() + 1}-${tempToValue.getDate()}`;

            newFilters.investment_date_from.value = [fromVal];
            newFilters.investment_date_to.value = [toVal];

            arFilters.push(newFilters.investment_date_from, newFilters.investment_date_to);
        } else if (key === 'region' || key === 'investmentRegion' || key === 'regionFocusLocation') {
            // resolved into real locations via getRegionLocations (geoFocusLocation) — sending
            // the raw region selection here would forward the synthetic pak-turkey id verbatim
            return;
        } else if (filterOptions[key]?.length > 0 && oldFilters[key].length > 0) {
            newFilters[key].value = [];

            for (let i = 0; i < oldFilters[key].length; i++) {
                const objFilter = oldFilters[key][i];

                if (objFilter.id === "ALL") {
                    const arrOptionsValue = filterOptions[key]
                        .filter(({ id }) => id && id !== "ALL")
                        .map(({ id }) => id);

                    newFilters[key].value = arrOptionsValue;
                    break;
                } else {
                    newFilters[key].value.push(objFilter.id);
                }
            }

            arFilters.push(newFilters[key]);
        } else {
            if (newFilters[key] && oldFilters[key] && oldFilters[key].length > 0) {
                if (Array.isArray(oldFilters[key])) {
                    newFilters[key].value = oldFilters[key].map(v => v.id).filter(id => id != null);

                    if (newFilters[key].value.length > 0) arFilters.push(newFilters[key]);
                } else {
                    newFilters[key].value = [oldFilters[key]];

                    arFilters.push(newFilters[key]);
                }
            }
        }
    });

    let finalFilters = prepareFilterParam(arFilters);
    if (!finalFilters) {
        finalFilters = "";
    }
    return finalFilters;
}

export const hasDirectoryFieldValue = (value) => (
    value !== undefined &&
    value !== null &&
    !(typeof value === 'string' && value === '') &&
    !(Array.isArray(value) && value.length === 0)
);

export const formatDirectoryAmount = (value) => {
    const parsedValue = Number(value);

    if (!Number.isFinite(parsedValue) || parsedValue === 0) {
        return "-";
    }

    return amountFormatter(parsedValue);
};

export const formatDirectoryRangeAmount = (range = {}) => {
    const minValue = Number(range?.min);
    const maxValue = Number(range?.max);
    const hasMin = Number.isFinite(minValue) && minValue > 0;
    const hasMax = Number.isFinite(maxValue) && maxValue > 0;

    if (hasMin && hasMax) {
        return minValue === maxValue
            ? formatDirectoryAmount(minValue)
            : `${formatDirectoryAmount(minValue)} - ${formatDirectoryAmount(maxValue)}`;
    }

    if (hasMin) {
        return `Above ${formatDirectoryAmount(minValue)}`;
    }

    if (hasMax) {
        return `Up to ${formatDirectoryAmount(maxValue)}`;
    }

    return "-";
};

export const formatDirectoryYear = (dateValue) => {
    const year = new Date(dateValue).getFullYear();
    return Number.isNaN(year) ? "-" : year;
};
